import {Module} from 'vuex';
import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';
import {ConnectedUserState} from './types';
import {StoreState} from '@/brief-hub/store/state/StoreState';

export const state: ConnectedUserState = {
    user: undefined,
    searchedIdentities: [],
};

export const connectedUser: Module<ConnectedUserState, StoreState> = {
    state,
    mutations,
    actions,
    getters,
};
